import React from "react";
import { t } from "@client/lib/dictionary";
import type { PipTelemetry } from "@client/types/pip";
import { Card, CardContent, CardHeader, CardTitle } from "@client/components/ui/card";

interface Props {
  telemetry: PipTelemetry | undefined;
}

/** PI30 QPIWS warning bit map — mirror z BE statusEnums.ts. */
const WARNING_LABELS: Record<number, string> = {
  1: "Porucha měniče",
  2: "BUS overvoltage",
  3: "BUS undervoltage",
  4: "BUS soft fail",
  5: "Síť selhala",
  6: "OPV short",
  7: "Inverter V too low",
  8: "Inverter V too high",
  9: "Přehřátí",
  10: "Ventilátor zablokovaný",
  11: "Baterie - vysoké napětí",
  12: "Baterie - nízké napětí",
  14: "Baterie - shutdown",
  16: "Přetížení",
  17: "Porucha EEPROM",
  18: "Inverter overcurrent",
  19: "Inverter soft fail",
  20: "Self-test fail",
  21: "OP DC voltage over",
  22: "Baterie odpojena",
  23: "Porucha proudového senzoru",
  24: "Baterie - zkrat",
  25: "Power limit",
  26: "PV napětí vysoké",
  27: "MPPT overload fault",
  28: "MPPT overload warning",
  29: "Baterie - příliš nízká pro nabíjení",
};

const isFault = (idx: number): boolean => [1, 2, 14, 17, 18, 22, 24].includes(idx);

export const PipAlarmsBar: React.FC<Props> = ({ telemetry }) => {
  const active = telemetry?.activeWarnings ?? [];
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t.pip.detail.alarms}</CardTitle>
      </CardHeader>
      <CardContent>
        {active.length === 0 ? (
          <div className="text-muted-foreground text-sm">{t.pip.detail.noAlarms}</div>
        ) : (
          <div className="flex flex-wrap gap-2">
            {active.map((idx) => {
              const label = WARNING_LABELS[idx] ?? `Warning #${idx}`;
              const color = isFault(idx) ? "bg-red-600 text-white" : "bg-amber-500 text-white";
              return (
                <span
                  key={idx}
                  className={`inline-flex items-center gap-1 text-xs font-medium rounded px-2 py-1 ${color}`}
                >
                  {label}
                </span>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
